// document.addEventListener("DOMContentLoaded", function () {
//     var elements = document.getElementsByClassName('form-submit-button');
//     const submitButton = elements[0];
//     if (submitButton) {
//         submitButton.disabled = true;
//     }
//     window.turnstileSuccess = function (token) {
//         if (submitButton) {
//             submitButton.disabled = false;
//         }
//     };
//     window.turnstileExpired = function () {
//         if (submitButton) {
//             submitButton.disabled = true;
//         }
//     };

//     window.turnstileError = function () {
//         if (submitButton) {
//             submitButton.disabled = true;
//         }
//     };
// });
document.addEventListener("DOMContentLoaded", function () {
    var elements = document.getElementsByClassName('form-submit-button');
    const submitButton = elements[0];

    function isButtonValid(button) {
        return button && !button.classList.contains('soldout-btn');
    }

    window.turnstileSuccess = function (token) {
        if (isButtonValid(submitButton)) {
            submitButton.removeAttribute('disabled');
        }
    };

    window.turnstileExpired = function () {
        if (isButtonValid(submitButton)) {
            submitButton.setAttribute('disabled', 'disabled');
        }
    };

    window.turnstileError = function () {
        if (isButtonValid(submitButton)) {
            submitButton.setAttribute('disabled', 'disabled');
        }
    };
});

